var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',_vm._g(_vm._b({attrs:{"true-value":_vm.trueValue,"false-value":_vm.falseValue,"input-value":_vm.status,"disabled":_vm.readonly,"label":_vm.showlabel}},'v-switch',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }